/* eslint-disable */

import React, { useEffect, useState, useContext } from "react";
import { monthlyAlert } from "../ContextApi/MonthlyAlert";
import icon from "../../assets/Invoice-Reminder.png";

export default function AltertModal() {
  const { showAlertModal, changeState } = useContext(monthlyAlert);
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    let timer;

    if (showAlertModal) {
      setShowIcon(false); // Reset icon visibility when modal opens
      timer = setTimeout(() => {
        setShowIcon(true); // Show close icon after 10 seconds
      }, 10000);
    }

    return () => clearTimeout(timer); // Cleanup timer on unmount or re-render
  }, [showAlertModal]);

  return (
    <>
      {showAlertModal && (
        <div className="modal" style={{ display: "block" }}>
          <div className="modal-content-Alert">
            <div className="row">
              <div className="col-12 page_headingAlert">
                {showIcon && (
                  <span
                    className="close pr-2 closeicon"
                    onClick={() => changeState(false)}
                  >
                    &times;
                  </span>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src={icon}
                  alt="icon"
                  style={{
                    marginTop: "10px",
                    margin: "0 auto",
                    width: "100%",
                  }}
                />
              </div>
              <marquee
                width="100%"
                direction="left"
                style={{ backgroundColor: "#5CD1D0", color: "white" }}
              >
                Your Invoice is due. Please clear the invoice at your earliest!
              </marquee>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
